import { render, staticRenderFns } from "./userPassword.vue?vue&type=template&id=96779b80&scoped=true"
import script from "./userPassword.vue?vue&type=script&lang=js"
export * from "./userPassword.vue?vue&type=script&lang=js"
import style0 from "./userPassword.vue?vue&type=style&index=0&id=96779b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96779b80",
  null
  
)

export default component.exports